/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity, enumeration } from '@gh/core-data';
import { CustomFieldDetailsDto } from '../models/custom-field-details.dto';
import { CustomFieldPlacement } from '../models/custom-field-placement.enum';
import { CustomFieldType } from '../models/custom-field-type.enum';

export const CustomFieldDetailsMapper = entity<CustomFieldDetailsDto>({
  placement: enumeration(CustomFieldPlacement),
  dataType: enumeration(CustomFieldType),
});
